/**
 * Check if a file is of a type specified in acceptedFileTypes
 * @param file               The file to check
 * @param acceptedFileTypes  An array of types, as file extensions (e.g. ".pdf") or mimetypes (e.g. "application/msword")
 */
export function isAcceptedFiletype(file: File, acceptedFileTypes: string[]) {
  if (!file) {
    return false;
  }

  // if accepted file types not specified, allow all files
  if (!acceptedFileTypes?.length) {
    return true;
  }

  const fileName = file.name;
  const extensionIndex = fileName.lastIndexOf('.');
  const extension = extensionIndex >= 0
    ? fileName.substring(extensionIndex)
      .toLowerCase()
    : '';
  return acceptedFileTypes.some(type => {
    type = type.toLowerCase();
    return type === extension || type === file.type;
  });
}
